<template>
  <b-modal size="lg" :id="id" hide-footer hide-header>
    <h1 class="text-center text-primary">Terms of Use</h1>
    <div v-html="tos"></div>
  </b-modal>
</template>

<script>
import { BModal } from 'bootstrap-vue'

export default {
  props: {
    id: {
      type: String,
      default: function() {
        return 'tos-modal'
      },
    },
  },

  components: {
    BModal,
  },

  data() {
    return {
      tos: '',
    }
  },

  mounted() {
    this.fetchTOS()
  },

  methods: {
    fetchTOS() {
      this.$http
        .get('/settings/terms-of-use')
        .then(({ data }) => {
          this.tos = data.data.content
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
    },
  },
}
</script>
